module.exports = __webpack_public_path__ + "img/rot10.aa1b2e32.jpg";